import { authenticatedApi } from "../api";
import { MICROSERVICE_CONFIG } from "../../config/configs";

export const get_all_transactions_history_api = async (params) => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.ACCOUNTING}/payouts?${params}`
	);
	return response.data;
};

export const get_all_transactions_orders_api = async (params) => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.ACCOUNTING}/orders?${params}`
	);
	return response.data;
};

export const getAllTransactionsDetails_api = async (id) => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.ACCOUNTING}/orders/${id}`
	);
	return response.data;
};

export const getAllPaymentHistoryDetails_api = async (id) => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.ACCOUNTING}/payouts/${id}`
	);
	return response.data;
};

export const downloadTransactionsHistory_api = async (params) => {
	const response = await authenticatedApi.post(
		`${MICROSERVICE_CONFIG.ACCOUNTING}/download/payouts`,
		params
	);
	return response.data;
};

export const downloadTransactionOrders_api = async (params) => {
	const response = await authenticatedApi.post(
		`${MICROSERVICE_CONFIG.ACCOUNTING}/download/orders`,
		params
	);
	return response.data;
};

export const getAllDashboardDetails_api = async (params) => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.ACCOUNTING}/dashboard${params ? `?${params}` : ""}`
	);
	return response.data;
};

export const get_restaurant_payouts_balance_api = async (params) => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.ACCOUNTING}/stripe/restaurant/${params}/balance`
	);
	return response.data;
};

export const add_restaurant_payouts_stripe_api = async (params) => {
	const response = await authenticatedApi.post(
		`${MICROSERVICE_CONFIG.ACCOUNTING}/stripe/restaurant/payout`,
		params
	);
	return response.data;
};

export const getUnclaimedPayouts = async (payload) => {
	const { restaurantId, queryParams } = payload;
	if (!restaurantId) return;
	const response = await authenticatedApi.get(
		`${
			MICROSERVICE_CONFIG.SUPERADMIN_BFF
		}/payouts/restaurant/${restaurantId}/unclaimed-gifts${
			queryParams ? `?${queryParams}` : ""
		}`
	);
	return response?.data;
};

export const initiateUnclaimedTransfer = async (payload) => {
	const { restaurantId, body } = payload;
	const response = await authenticatedApi.post(
		`${MICROSERVICE_CONFIG.ACCOUNTING}/payouts/restaurant/${restaurantId}/unclaimed-gifts/transfer`,
		body
	);
	return response?.data;
};
